import React from "react";
import LegalLayout from "@/components/site/LegalLayout";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-outfit text-2xl md:text-3xl font-medium text-white">
      {title}
    </h2>
    <div className="space-y-3 text-white/70">{children}</div>
  </section>
);

export default function CGV() {
  return (
    <LegalLayout
      kicker="Contrat"
      title="Conditions Générales de Vente"
    >
      <p>
        Les présentes Conditions Générales de Vente (ci-après «&nbsp;CGV&nbsp;»)
        régissent les relations contractuelles entre EM Group, cabinet de
        conseil digital dont le siège est au 60 rue François 1
        <sup>er</sup>, 75008 Paris (ci-après «&nbsp;le Prestataire&nbsp;»), et
        toute personne physique ou morale passant commande (ci-après «&nbsp;le
        Client&nbsp;»).
      </p>

      <Section title="1. Objet et services proposés">
        <p>EM Group propose les prestations suivantes :</p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>
            <span className="text-white">Branding&nbsp;:</span> création
            d&rsquo;identité visuelle, logos, charte graphique, univers de
            marque (Pack Logo Essentiel, Pack Branding Complet, Pack
            Visibilité).
          </li>
          <li>
            <span className="text-white">Création de visuels&nbsp;:</span>{" "}
            visuels réseaux sociaux, supports publicitaires, print, à
            l&rsquo;unité ou en packs.
          </li>
          <li>
            <span className="text-white">Sites web&nbsp;:</span> création de
            sites vitrines et e-commerce, selon 3 formules — achat, paiement
            en plusieurs fois, location mensuelle.
          </li>
          <li>
            <span className="text-white">Audit de site&nbsp;:</span>{" "}
            analyse design, UX, conversion et SEO avec rapport écrit.
          </li>
          <li>
            <span className="text-white">Accompagnement complet&nbsp;:</span>{" "}
            prestation globale incluant branding, visuels, site, stratégie et
            lancement.
          </li>
          <li>
            <span className="text-white">Abonnements mensuels&nbsp;:</span>{" "}
            formules Starter, Pro et Premium pour gestion et création de
            contenu récurrent.
          </li>
        </ul>
      </Section>

      <Section title="2. Commande et devis">
        <p>
          Toute prestation fait l&rsquo;objet d&rsquo;un devis écrit,
          personnalisé et gratuit, transmis par EM Group suite à une
          demande du Client. Le devis précise la nature de la prestation, le
          prix, les délais et les modalités de paiement.
        </p>
        <p>
          La commande est considérée comme ferme et définitive dès réception
          par EM Group du devis signé et de l&rsquo;acompte mentionné.
        </p>
      </Section>

      <Section title="3. Prix et modalités de paiement">
        <p>
          <span className="text-white">
            Tous les prix affichés sur le Site et dans les devis sont exprimés
            en euros (€) et s&rsquo;entendent <strong>toutes taxes comprises (TTC)</strong>.
          </span>{" "}
          Ils incluent l&rsquo;ensemble des taxes applicables au jour de la
          commande et s&rsquo;appliquent indifféremment aux particuliers
          comme aux professionnels, conformément à l&rsquo;article L.112-1
          du Code de la consommation.
        </p>
        <p>
          Les prix indiqués sur le Site sont susceptibles d&rsquo;évoluer ;
          le prix applicable est celui en vigueur au jour de l&rsquo;émission
          du devis. La mention «&nbsp;à partir de&nbsp;» signifie que le prix
          final peut varier selon la complexité du projet, le périmètre et
          les besoins spécifiques du Client. Chaque devis personnalisé
          précise le prix final TTC, les délais et les modalités de paiement.
        </p>
        <p>
          <span className="text-white">Modalités acceptées :</span>
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>
            <span className="text-white">Paiement comptant&nbsp;:</span> carte
            bancaire via Stripe, virement bancaire.
          </li>
          <li>
            <span className="text-white">Paiement en plusieurs fois&nbsp;:</span>{" "}
            2, 3 ou 4 mensualités sans frais selon le devis.
          </li>
          <li>
            <span className="text-white">Abonnement mensuel&nbsp;:</span>{" "}
            prélèvement automatique mensuel via Stripe.
          </li>
        </ul>
        <p>
          Un <span className="text-white">acompte de 50%</span> est demandé à
          la signature du devis pour toute prestation ponctuelle. Le solde
          est dû à la livraison.
        </p>
        <p>
          Une facture détaillée mentionnant le prix TTC, ainsi que toutes les
          mentions légales obligatoires, est systématiquement adressée au
          Client après paiement.
        </p>
        <p>
          Tout retard de paiement entraîne, sans mise en demeure préalable,
          des pénalités au taux légal en vigueur ainsi qu&rsquo;une indemnité
          forfaitaire pour frais de recouvrement de 40&nbsp;€ (article
          L.441-10 du Code de commerce, applicable entre professionnels).
        </p>
      </Section>

      <Section title="4. Délais de réalisation">
        <p>Les délais indicatifs, à confirmer dans chaque devis, sont :</p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>
            <span className="text-white">Visuel unique&nbsp;:</span> 24h à 72h.
          </li>
          <li>
            <span className="text-white">Packs visuels&nbsp;:</span> 3 à 7 jours.
          </li>
          <li>
            <span className="text-white">Pack Logo Essentiel&nbsp;:</span> 5 à
            10 jours.
          </li>
          <li>
            <span className="text-white">Pack Branding Complet&nbsp;:</span> 2
            à 3 semaines.
          </li>
          <li>
            <span className="text-white">Site web&nbsp;:</span> 2 à 6 semaines.
          </li>
          <li>
            <span className="text-white">Audit de site&nbsp;:</span> 3 à 5 jours.
          </li>
          <li>
            <span className="text-white">Accompagnement complet&nbsp;:</span>{" "}
            défini sur-mesure au démarrage.
          </li>
        </ul>
        <p>
          Les délais commencent à courir à compter de la réception de
          l&rsquo;acompte et des éléments nécessaires fournis par le Client
          (brief, contenus, accès).
        </p>
      </Section>

      <Section title="5. Conditions de modification">
        <p>Sauf mention contraire sur le devis :</p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>
            <span className="text-white">Visuel unique&nbsp;:</span> 1
            révision incluse.
          </li>
          <li>
            <span className="text-white">Pack 2 visuels&nbsp;:</span> 2
            révisions incluses.
          </li>
          <li>
            <span className="text-white">Pack 4 visuels & Branding
            Complet&nbsp;:</span> révisions illimitées jusqu&rsquo;à
            satisfaction.
          </li>
          <li>
            <span className="text-white">Site web&nbsp;:</span> 2 phases de
            révisions incluses (design, développement).
          </li>
        </ul>
        <p>
          Toute modification substantielle du brief en cours de projet peut
          donner lieu à un avenant facturable.
        </p>
      </Section>

      <Section title="6. Conditions d'annulation">
        <p>
          Toute annulation d&rsquo;une prestation ponctuelle doit être
          notifiée par écrit à{" "}
          <a
            href="mailto:contact@emgroupdigital.com"
            className="text-[#E52431] hover:underline"
          >
            contact@emgroupdigital.com
          </a>
          .
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>
            <span className="text-white">Avant démarrage des travaux&nbsp;:</span>{" "}
            l&rsquo;acompte reste acquis à EM Group à titre de frais
            d&rsquo;étude.
          </li>
          <li>
            <span className="text-white">En cours d&rsquo;exécution&nbsp;:</span>{" "}
            le Client règle les travaux déjà effectués, sur présentation
            d&rsquo;un récapitulatif détaillé.
          </li>
          <li>
            <span className="text-white">Droit de rétractation&nbsp;:</span>{" "}
            conformément à l&rsquo;article L.221-28 du Code de la
            consommation, le droit de rétractation ne s&rsquo;applique pas
            aux prestations personnalisées démarrées avec l&rsquo;accord du
            Client.
          </li>
        </ul>
      </Section>

      <Section title="7. Gestion des abonnements">
        <p>
          Les formules d&rsquo;abonnement mensuel (Starter, Pro, Premium) et
          de location de site sont reconduites tacitement chaque mois.
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>
            <span className="text-white">Abonnements visuels (Starter /
            Pro / Premium)&nbsp;:</span> sans engagement, résiliables à tout
            moment avec un préavis de 30 jours par email à{" "}
            <a
              href="mailto:contact@emgroupdigital.com"
              className="text-[#E52431] hover:underline"
            >
              contact@emgroupdigital.com
            </a>
            .
          </li>
          <li>
            <span className="text-white">Location mensuelle de site&nbsp;:</span>{" "}
            engagement minimum de 12 mois. Au-delà, la reconduction se fait
            au mois, résiliable avec un préavis de 30 jours. Toute
            résiliation anticipée avant 12 mois entraîne le paiement des
            mensualités restantes.
          </li>
          <li>
            Aucun remboursement n&rsquo;est effectué pour un mois entamé.
          </li>
        </ul>
      </Section>

      <Section title="8. Propriété intellectuelle">
        <p>
          Les créations livrées deviennent la propriété du Client à réception
          du paiement intégral. EM Group conserve le droit d&rsquo;utiliser
          les travaux réalisés à titre de référence (portfolio, réseaux
          sociaux) sauf demande contraire écrite du Client.
        </p>
        <p>
          Dans le cadre de la location mensuelle de site, le Client bénéficie
          d&rsquo;un droit d&rsquo;usage exclusif du site pendant toute la
          durée du contrat. Le code source reste la propriété d&rsquo;EM
          Group.
        </p>
      </Section>

      <Section title="9. Responsabilité">
        <p>
          EM Group est tenu à une obligation de moyens. Sa responsabilité ne
          pourra être engagée en cas de faute du Client, de retard dans la
          fourniture des éléments nécessaires ou de cas de force majeure.
        </p>
      </Section>

      <Section title="10. Confidentialité">
        <p>
          Chaque partie s&rsquo;engage à préserver la confidentialité des
          informations échangées dans le cadre de la prestation.
        </p>
      </Section>

      <Section title="11. Données personnelles">
        <p>
          Le traitement des données personnelles du Client est détaillé dans
          notre{" "}
          <a href="/confidentialite" className="text-[#E52431] hover:underline">
            Politique de confidentialité
          </a>
          .
        </p>
      </Section>

      <Section title="12. Litiges et droit applicable">
        <p>
          Les présentes CGV sont soumises au droit français. En cas de
          litige, les parties s&rsquo;efforcent de trouver une solution
          amiable. À défaut, les tribunaux compétents seront ceux du ressort
          du siège social d&rsquo;EM Group.
        </p>
      </Section>
    </LegalLayout>
  );
}
